<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="trinka_cloud_banner_text">
                        <h1>Melhora a Qualidade da Redação e os Fluxos de Trabalho Editorial </h1>
                        <p>Permite que suas equipes escrevam de forma consistente, publiquem com mais rapidez e aumenta a experiência
                            do cliente. Reduz o tempo e os custos de edição sem sacrificar a clareza, consistência, percepção
                            da marca ou estilo.
                        </p>
                        <button data-toggle="modal"
                            data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma Cotação</button>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../../assets/images/language-services-publishing-and-media.png" alt="Trinka enterprise" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="most_suited_for_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="most_united_heading">
                        <h2>
                            <span></span>Soluções Adequadas à Indústria para</h2>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="most_suited_point">
                        <ul>
                            <li>Empresas de Revisão e Edição</li>
                            <li>Midia e Editoras</li>
                            <li>Blogueiros e Sites de Blogs</li>
                            <li>Empresas de Serviço de Tradução</li>
                            <li>Estabelecimentos de Pré-impressão</li>
                            <li>Agências de Marketing</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-2">
                    <h2>Aprovado por Líderes Globais</h2>
                </div>
                <div class="col-sm-10">
                    <div class="cover_wrapper">
                        <div id="client-logos-enterprise" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/alternet.png" alt="leaders">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/HarperCollinsPublishers.png" alt="leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/scholastic.png" alt="leaders">
                                </div>
                            </div>
                            <!-- <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/RightlyWritten.png" alt="leaders">
                                </div>
                            </div> -->
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/sanchini.png" alt="leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/technica.png" alt="leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/CapstoneWriting.png" alt="leaders">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/client_logos/evolution_editing.png" alt="leaders">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="wayToIntegrateTrinka">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="integreate_heading_section">
                        <h2>Recursos Empresariais que Ajudam as Suas Equipes a Escreverem Melhor</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka auxilia as suas equipes na criação de documentos críticos de forma eficiente, garantindo qualidade
                            e conformidade de acordo com as convenções de redação científica.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ul>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../../assets/images/BulkEditingOperations.svg" alt="bulk editing" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Operações de Edição em Massa</h3>
                                    <p>Carregue seus documentos em formato MS Word e relaxe enquanto Trinka os edita em minutos.
                                        Basta baixar os arquivos editados e revisar todas as alterações para finalizar o
                                        seu conteúdo.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../../assets/images/MedicalSpellCheckicon.svg" alt="medical spell" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Veificação Ortográfica Contextual e Dicionário </h3>
                                    <p>O corretor ortográfico integrado da Trinka sabe a diferença entre "de" (from) e "forma"
                                        (form) e também conhece milhões de palavras técnicas. Cada membro da equipe pode
                                        criar dicionários pessoais ou usar um único para manter toda a sua comunicação sobre
                                        a marca com facilidade. </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../../assets/images/WordCountreductions.png" alt="word count" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Reduções de Contagem de Palavras</h3>
                                    <p>Trinka ajuda você a deixar o seu ponto de vista conciso, permitindo que você entregue
                                        a sua mensagem com o impacto certo. Suas equipes também aprendem enquanto escrevem!</p>
                                </div>
                            </div>

                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../../assets/images/Suggestionsthatmatchyourtone.png" alt="suggestions" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Sugestões que Correspondem ao Seu Tom</h3>
                                    <p>Trinka AI oferece as sugestões certas, quer você esteja escrevendo uma peça casual ou
                                        um documento formal. Para documentos de pesquisa, você pode até definir o tipo de
                                        pesquisa - desde pesquisa original e revisões a relatos de casos.
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/EasyUserManagement.svg" alt="easy use" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Gerenciamento Fácil de Usuários</h3>
                                    <p>Sua conta de equipe permite que você adicione ou remova membros facilmente. Gerencie créditos e limites de uso em tempo real. O gerenciamento de acesso é fácil e seguro com os
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../assets/images/ppc_icon.png" width="40" height="40" alt="ppc" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Verificação de Plágio </h3>
                                    <p>A mais alta qualidade de verificação de plágio, com o algoritmo mais avançado de detecção de semelhança de textos, iThenticate e o maior banco de dados de publicações pagas.
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../../assets/images/ComprehensiveAnalytics.svg" alt="Comprehensive Analytics" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Análise Abrangente</h3>
                                    <p>Veja como as suas equipes usam Trinka ou aprofunde-se na atividade de cada usuário com
                                        uma análise rica para uma tomada de decisão eficaz.
                                    </p>
                                </div>
                            </div>
                        </li>

                        <li>
                            <div class="features_cards">
                                <div class="features_cards_icon">
                                    <img src="../../../../assets/images/DedicatedSupport.svg" alt="Dedicated Support" srcset="">
                                </div>
                                <div class="features_cards_desc">
                                    <h3>Suporte Dedicado</h3>
                                    <p>Um Gerente de Sucesso dedicado é designado para apoiar a sua equipe com o objetivo de
                                        obter o máximo do verificador Trinka. Isso inclui uma chamada de integração minuciosa,
                                        documentação de ajuda e orientações em vídeo.
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <span class="bottom_diviedLine"></span>
                    <span class="bottom_diviedLine1"></span>

                </div>
            </div>

        </div>
    </div>
</div>

<div class="advanceGrammerSpellCheck_section backgrondSecitons_outer accomplishSections sec2">
    <div class="container">
        <div class="row">
            <div class="col-xl-4">
                <div class="spellcheck_heading EnhancementsHeadingSection">
                    <h2>Assistência para Todos os Casos de Uso</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Descubra o verdadeiro poder do Trinka com a ajuda de casos de uso personalizado para setores e funções
                        específicas.
                    </p>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="all_usecases">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Assistência Poderosa para Editores de Conteúdo</h4>
                                <p>Permita que Trinka corrija problemas gramaticais e mecânicos avançados e que seus editores
                                    especialistas se concentrarem na semântica e na entrega. Isso melhora a qualidade da
                                    saída e ajuda a otimizar o fluxo de trabalho.</p>
                                <ul>
                                    <li>Melhor tempo de resposta para projetos</li>
                                    <li>Qualidade editorial aprimorada</li>
                                    <li>Tempo reduzido para publicação</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Para Equipes de Marketing</h4>
                                <p>Permita que as suas equipes criem e-mails de clientes, material de marketing, comunicações,
                                    relatórios, argumentos de venda melhores e muito mais com as sugestões precisas do Trinka.</p>
                                <ul>
                                    <li>Evite erros embaraçosos nas comunicações com o cliente</li>
                                    <li>Fique conectado com a marca com facilidade</li>
                                    <li>Reduza o tempo de entrega dos conteúdos</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Para Avaliação da Qualidade Editorial</h4>
                                <p>Avaliação de redação do Trinka AI oferece insights úteis com pontuações personalizáveis e
                                    separações de erros por categoria.</p>
                                <ul>
                                    <li>Insights quantitativos sobre qualidade</li>
                                    <li>Assistência com contratação editorial</li>
                                    <li>Oportunidades de aprendizado com explanações e dicas</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="all_usecases_item">
                                <h4>Verificações Gramaticais Automatizadas Após Traduções</h4>
                                <p>As equipes de tradução podem usar o Trinka para melhorar suas traduções em inglês com correções
                                    gramaticais precisas e obter insights de qualidade.</p>
                                <ul>
                                    <li>Verificações ortográficas contextuais</li>
                                    <li>Melhorias técnicas no fraseado e na estrutura das frases</li>
                                    <li>Edição automatizada de arquivos para fluxo de trabalho de alto rendimento</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<div class="softWare_workFlow cloud_key_features">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="brandlogo_heading key_features_heading">
                    <h2>Integre com seu Software Proprietário e Fluxos de Trabalho</h2>
                </div>
                <div class="HeadingSubLine"></div>
                <p>As integrações fáceis de Trinka permitem que suas equipes desfrutem de todos os benefícios diretamente no
                    software existente, tornando a escrita eficaz, produtiva e contínua.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>JavaScript</h3>

                    <p>
                        Habilite Trinka para todos os membros de sua equipe simplesmente inserindo um pequeno trecho de código JavaScript (JS) em
                        seu navegador ou qualquer aplicativo.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>API</h3>
                    <p>
                        O poderoso verificador Trinka API traz Trinka direto para seus aplicativos existentes. Com uma arquitetura de API simples,
                        é fácil de integrar.</p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Na Premissa</h3>
                    <p>Garanta uma redação eficaz e máxima confidencialidade com Trinka hospedado em sua infraestrutura corporativa,
                        seja em servidores locais ou em nuvem.
                    </p>

                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Cloud Editor</h3>


                    <p>
                        Use todo o potencial de Trinka em qualquer lugar, com o aplicativo seguro baseado na web.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">

                    <h3>Suplemento MS Word</h3>
                    <p>
                        Aumente a produtividade de suas equipes com sugestões de redação fornecidas no MS Word.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="features_cards">
                    <h3>Plug-ins no Navegador</h3>
                    <p>
                        Assistência de redação em tempo real em qualquer site da Web por meio de plug-ins para todos os seus navegadores favoritos.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="most_suited_for_section pricing_works">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="brandlogo_heading">
                    <h2>Preços Personalizados que Funcionam para Você</h2>
                </div>
                <p>Trinka oferece preços flexíveis para usuário ou baseados no uso para atender às suas necessidades exclusivas.
                    <br>Troque de usuário e aplique restrições de uso em tempo real, sem nenhum custo extra.
                    <br>Trabalharemos com você para criar um contrato personalizado sem complicações e uma opção de pagamento
                    único por meio de pedido de compra / fatura. </p>
            </div>

            <div class="col-lg-12">
                <div class="try_trinka_Buttons">
                    <!-- <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Get a Quote</a> -->

                    <button data-toggle="modal"
                        data-target="#EnterPriseContactPopup" class="plansButtons" type="submit">Obtenha uma cotação</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="writeToolboxs_section">
    <div class="writeToolbox_inner_sections">
        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Seguro e confiável</h3>
                        <p>Trinka coloca a segurança e a privacidade dos dados em primeiro plano. Todos os seus dados são fortemente
                            criptografados e armazenados com segurança - ninguém mais tem acesso aos seus dados. Oferecemos
                            planos exclusivos que eliminam completamente o salvamento de qualquer dado assim que você receber
                            sugestões de redação.
                        </p>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/safe-secure.png" alt="dafe secure" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolbox_inner_sections sections_height_set publicationCheckSections" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="toolbox_img_content">
                        <img src="../../../assets/images/about-ai.png" alt="about ai" class="img-fluid">
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="toolbox_text_content">
                        <h3>Sobre a AI</h3>
                        <p>Trinka usa as mais recentes técnicas de aprendizado de máquina (ML) e processamento de linguagem
                            natural (PNL) para identificar erros gramaticais e sugerir aprimoramentos de linguagem. Ele é
                            treinado em milhões de documentos e artigos bem escritos que abrangem mais de 1300 áreas, incluindo
                            medicina, ciências biológicas, biologia , ciências físicas, engenharia, humanas, negócios e artes
                            para dar a você as sugestões mais relevantes.</p>
                        <p>Trinka é desenvolvido por uma equipe de lingüistas, editores médicos, cientistas de dados e engenheiros
                            com um profundo desejo de criar um futuro com comunicação sem barreiras.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="enterprise_contactUs">
    <p>Transforme sua comunicação empresarial com Trinka</p>
    <button data-toggle="modal" data-target="#EnterPriseContactPopup"
        class="plansButtons" type="submit">Obtenha uma cotação</button>
</div>


<app-enterprise-modal></app-enterprise-modal>